export default {
    article: "Artikel",
    tax: "MwSt",
    quantity: "Menge",
    price: "Preis",
    total: "Gesamt",
    noArticles: "Keine Artikel",
    redeemedCoupons: "Eingelöste Gutscheine"
}
